import React from 'react';
import PropTypes from 'prop-types';
import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { Quote } from '@sm360/widget-commons-vehicle';

import InstantEstimate from 'trade-in/components/InstantEstimate/InstantEstimate.jsx';

const TradeInBarWrapper = ({ style, isShowroomV2Enabled, quote }) => {
    const czHasCbb = ContentZonesService.getContentZone('widget.tradein', 'widget.tradein.hascbb');
    if (!czHasCbb || (czHasCbb && czHasCbb.getValue() !== 'true')) {
        return null;
    }
    return (
        <div id="instant-estimate-bar-wrapper" style={style}>
            <InstantEstimate
                parentElementId="instant-estimate-bar-wrapper"
                isShowroomV2Enabled={isShowroomV2Enabled}
                quote={quote}
            />
        </div>
    );
};

TradeInBarWrapper.defaultProps = {
    style: {},
    isShowroomV2Enabled: false,
    quote: undefined,
};

TradeInBarWrapper.propTypes = {
    style: PropTypes.objectOf(PropTypes.string),
    isShowroomV2Enabled: PropTypes.bool,
    quote: PropTypes.instanceOf(Quote.QuoteModel),
};

TradeInBarWrapper.displayName = 'TradeInBarWrapper';

export default TradeInBarWrapper;
